import React from "react";
import { getCommonParam } from "../config";
import Costanti from "../constantiX";
import { Button } from "primereact";
import { useToast } from "../hooks/use-toast";
import axios from "axios";

const ProductImage = ({ aziendaId, itemId, table, operationType, isDirty, hasImage, label }) => {
  const { toastRef } = useToast();
  const imgsrc = Costanti.UrlCallApi + "file/get/" + aziendaId + "/" + table + "/" + itemId;
  const deleteImage = async () => {
    try {
      const apiCommonParam = getCommonParam();
      const { apiUrl, axiosConfig, user } = apiCommonParam;
      await axios.get(`${apiUrl}file/delete/${user.aziendaid}/${table}/${itemId}`, axiosConfig);
      toastRef.current.showToast("success", "Immagine eliminata correttamente", "");
      window.location.reload();
    } catch (error) {
      console.log(error);
      toastRef.current.showToast("error", error, "");
    }
  };
  return (
    <>
      <div className="flex border-3  border-gray-100 flex-column w-full justify-content-center  align-content-center">
        <label className="px-2 align-self-start text-sm my-2">{label ? label : "Immagine"}</label>

        {hasImage.startsWith("video") ? (
          <video width="240" height="240" controls autoPlay muted={true}>
            <source src={imgsrc} alt="" />
          </video>
        ) : (
          <img src={imgsrc} width={100} alt="" className="align-self-center" />
        )}
      </div>
      {((operationType !== "D" && operationType !== "V") || (operationType === undefined && hasImage)) && (
        <Button
          type="button"
          disabled={isDirty}
          label="Elimina Immagine"
          className="w-full mt-2 p-button-outlined p-button-danger "
          onClick={deleteImage}
        />
      )}
    </>
  );
};

export default ProductImage;
